<template>
    <div>
        <div class="white-box md:mb-5">
            <transition
                name="opacity"
                mode="out-in"
            >
                <Skeletons v-if="isGettingData" />
                <div v-else>
                    <div class="text-base mb-7 py-4 md:py-5">
                        <h4 class="text-secondary mb-2.5 font-bold">
                            請選擇欲辦理之內容
                        </h4>
                        <Radio
                            v-model:checkedValue="isApply"
                            :value="true"
                            text="主契約及所有壽險附約辦理繳清，且同時取消其他附約。(辦理繳清後，紅利選擇方式悉依條款辦理)"
                            class="mb-2.5 items-baseline"
                        />
                    </div>
                </div>
            </transition>
        </div>
        <Bottombar>
            <template #right>
                <ButtonNextService
                    v-model:isSubmitOk="isSubmitOk"
                    :disabled="isApply===false || isGettingData"
                    @click="saveAndgoNext"
                />
            </template>
        </Bottombar>
        <Loading :isLoading="isLoading" />
    </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { getInfoC1, submitC1 } from '@/apis/C1';
import Bottombar from '@/components/layout/Bottombar.vue';
import ButtonNextService from '@/components/buttons/ButtonNextService.vue';
import Loading from '@/components/Loading.vue';
import Radio from '@/components/radios/Radio.vue';
import Skeletons from '@/components/skeletons/Skeletons.vue';

export default {
    components: {
        Bottombar,
        Loading,
        Radio,
        ButtonNextService,
        Skeletons,
    },
    setup() {
        const route = useRoute();
        const { code } = route.meta;
        const store = useStore();
        /** 正在取得資料 */
        const isGettingData = ref(false);
        const isApply = ref(false);
        const isSubmitOk = ref(false);
        const isLoading = ref(false);
        const result = computed(() => store.state.services.changeItemsResult[code]);

        // 取得api資料
        const getData = () => {
            isGettingData.value = true;
            getInfoC1().then((res) => {
                // isApply.value = res.data.isApply;
            }).finally(() => {
                isGettingData.value = false;
            });
        };
        if (!result.value) {
            getData();
        } else {
            const { storeIsApply } = result.value;
            isApply.value = storeIsApply;
        }

        const saveAndgoNext = () => {
            isLoading.value = true;
            const returnData = {
                apply: isApply.value,
            };
            submitC1(returnData).then(() => {
                isSubmitOk.value = true;
                const value = {
                    storeIsApply: isApply.value,
                };
                store.dispatch('services/setChangeItemsResult', { code, value });
            }).finally(() => {
                isLoading.value = false;
            });
        };

        return {
            isGettingData,
            isLoading,
            isSubmitOk,
            isApply,
            saveAndgoNext,
        };
    },
};
</script>
